import React, { ReactElement } from 'react';
import { Form, Modal } from 'react-bootstrap';
import './VoicePairSettingModal.scss';
import { LiveProps } from '../../LiveContainer';
import { useSettingPairMutation } from '../../../../services/api/apiProvider';

export const VoicePairSettingModal = (props: LiveProps): ReactElement => {
  const [settingPair] = useSettingPairMutation();
  const handleChangePair = (event: any) => {
    props.changeAcceptPair(event.target.checked);
  };
  const handleCloseModalSettingPair = () => {
    if (props.liveState.pairType === 'pair') {
      props.changeAcceptPair(true);
    } else {
      props.changeAcceptPair(false);
    }
    props.toggleSettingPairModal(false);
  };

  const handleUpdateSettingPair = async () => {
    const idRadio = props.liveState.liveData?.radio?.id;
    if (idRadio) {
      if (props.liveState.isAcceptPair) {
        await settingPair({ id: idRadio, type: 'pair' });
        props.changeAcceptPair(true);
      } else {
        if (props.liveState.userPair) {
          props.toggleRemoveUserPairModal(true);
          if (
            !props.liveState.isShowRemoveUserPairModal &&
            !props.liveState.userPair
          ) {
            await settingPair({ id: idRadio, type: 'none' });
          }
        } else {
          settingPair({ id: idRadio, type: 'none' });
        }
        props.changeAcceptPair(false);
      }

      props.toggleSettingPairModal(false);
    }
  };

  return (
    <Modal
      show={props.liveState.isShowSettingPairModal}
      centered
      size="sm"
      backdrop="static"
      className="voiceguest-setting-modal"
    >
      <div className="voiceguest-setting-modal-wrapper">
        <div className="voiceguest-setting-modal-title">Pair配信設定</div>
        <div className="voiceguest-setting-modal-body">
          <div className="voiceguest-setting-modal-body-turn">
            <div className="voiceguest-setting-modal-body-turn-label">
              ペアを募集する
            </div>
            <Form>
              <Form.Check // prettier-ignore
                type="switch"
                id="custom-switch"
                label=""
                style={{ fontSize: '20px' }}
                checked={props.liveState.isAcceptPair}
                onChange={handleChangePair}
              />
            </Form>
          </div>
          <div className="voiceguest-setting-modal-body-btns">
            <button
              className="voiceguest-setting-modal-body-btn-cancel"
              onClick={handleCloseModalSettingPair}
            >
              キャンセル
            </button>
            <button
              className="voiceguest-setting-modal-body-btn-agree on"
              onClick={handleUpdateSettingPair}
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
